export default {"src":"/_next/static/media/college12.361fbe82.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};